import { SimulationSteps } from './types'

export const INITIAL_FOW = [SimulationSteps.POSTAL_CODE, SimulationSteps.ENERGY_TYPE, SimulationSteps.USAGE, SimulationSteps.PROPOSITION]

// The minimum for a usage to not be an "unusual" usage
export const MIN_USAGE_FOR_USUAL = 100

export const LEAD_GEN_SALES_CAMPAIGN_SO = 'lead_gen_sales_campaign_so'
